import { render, staticRenderFns } from "./QuestionFaisabiliteNew.vue?vue&type=template&id=eddb9186&scoped=true&"
import script from "./QuestionFaisabiliteNew.vue?vue&type=script&lang=js&"
export * from "./QuestionFaisabiliteNew.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFaisabiliteNew.vue?vue&type=style&index=0&id=eddb9186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb9186",
  null
  
)

export default component.exports